import { useEffect, useState } from 'react';
export function durationSeconds(row, elapsed = 0, now = Date.now()) {
  if (Number.isFinite(row?.time_in_state_seconds)) return Math.max(0, Math.floor(row.time_in_state_seconds + elapsed));
  const since = Date.parse(row?.since);
  return Number.isFinite(since) ? Math.max(0, Math.floor((now - since) / 1000)) : 0;
}
export const durationLabel = seconds => `${Math.floor(seconds / 3600)}:${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
export function useDuration(row) {
  const [elapsed, tick] = useState(0);
  const active = Boolean(row);
  useEffect(() => { tick(0); if (!active) return undefined; const timer = setInterval(() => tick(value => value + 1), 1000); return () => clearInterval(timer); }, [active, row?.since, row?.time_in_state_seconds]);
  return durationLabel(durationSeconds(row, elapsed));
}
